import styled, { css } from 'styled-components';
import { Children, isValidElement } from 'react';
import Panel from '.';
import { uiPrimaryColor } from '../../style/colors';

const TabsHeader = styled.div`
    display: flex;
    margin-bottom: 8px;
    border-bottom: 1px solid #ccc;
`;

const inactiveTabLabelStyle = css`
    color: #666;
    border-color: transparent;
    cursor: pointer;

    &:hover {
        color: #000;
    }
`;

const activeTabLabelStyle = css`
    color: ${uiPrimaryColor};
    border-color: ${uiPrimaryColor};
    cursor: default;
`;

const TabLabel = styled.div`
    flex: 1 1 0;
    border-bottom: 2px solid transparent;
    text-align: center;
    padding-bottom: 2px;

    ${(props) => (props.active ? activeTabLabelStyle : inactiveTabLabelStyle)}
`;

const TabPanel = ({ children, tabs, activeTab, setActiveTab, ...props }) => {
    const tabsContent = Children.toArray(children).filter((child) =>
        isValidElement(child)
    );

    const activeTabIndex = tabs.indexOf(activeTab);

    const getClickHandler = (tabId) => () => setActiveTab(tabId);

    return (
        <Panel {...props}>
            <TabsHeader>
                {tabs.map((label) => {
                    return (
                        <TabLabel
                            key={label}
                            active={label === activeTab}
                            onClick={getClickHandler(label)}
                        >
                            {label}
                        </TabLabel>
                    );
                })}
            </TabsHeader>
            <div>{tabsContent[activeTabIndex]}</div>
        </Panel>
    );
};

export default TabPanel;
